import { Paper } from "@mui/material";
import CustomText from "components/typography/CustomText";
import moment from "moment";
import { statusOption } from "pages/staff/StaffComponent";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomerDialog from "../../../components/CustomerDialog";

export default function CustomerInfo({
  data = {},
  type = "",
  onEditUser = () => {},
  onChangePhoneCode = () => {},
}) {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const handleEditUser = () => {
    setOpen(true);
  };
  const handleClickUser = () => {
    history.push(`/customers/${data?.user_id}`);
  };

  return (
    <div className="flex w-full">
      <Paper className="w-full">
        <div className="p-4 flex justify-between items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            Customer Info
          </CustomText>
          <CustomText
            className="cursor-pointer"
            onClick={handleEditUser}
            variant="h6"
            color="primary"
          >
            Edit
          </CustomText>
        </div>
        <div className="p-4">
          <div className="py-2">
            <CustomText className="text-xs" variant="body2">
              NAME
            </CustomText>
            <CustomText
              className="text-sm cursor-pointer"
              variant="body"
              color="primary"
              onClick={handleClickUser}
            >
              {data?.name}
            </CustomText>
          </div>
          <div className="py-2">
            <CustomText className="text-xs" variant="body2">
              EMAIL
            </CustomText>
            <CustomText
              className="text-sm cursor-pointer"
              variant="body"
              color="primary"
            >
              <a href={`mailto:${data?.email}`}>{data?.email}</a>
            </CustomText>
          </div>
          {type !== "user-detail" && (
            <div className="py-2">
              <CustomText className="text-xs" variant="body2">
                ADDRESS
              </CustomText>
              <CustomText className="text-sm" variant="body" color="primary">
                {data?.address?.label ?? "Not yet"}
              </CustomText>
            </div>
          )}
          <div className="py-2">
            <CustomText className="text-xs" variant="body2">
              PHONE NUMBER
            </CustomText>
            <CustomText className="text-sm" variant="body" color="primary">
              {data?.phone ?? "Not yet"}
            </CustomText>
          </div>
          <div className="py-2">
            <CustomText className="text-xs" variant="body2">
              LANDLINE PHONE
            </CustomText>
            <CustomText className="text-sm" variant="body" color="primary">
              {data?.landphone ?? "Not yet"}
            </CustomText>
          </div>
          <div className="py-2">
            <CustomText className="text-xs" variant="body2">
              JOINED
            </CustomText>
            <CustomText className="text-sm" variant="body" color="primary">
              {moment(data?.user_joined, "YYYY-MM-DD").format("MMM.YYYY")}
            </CustomText>
          </div>
        </div>
      </Paper>
      <CustomerDialog
        open={open}
        data={{
          phone_code: data?.phone_code ?? "64",
          id: data?.user_id,
          name: data?.name ?? "",
          email: data?.email ?? "",
          phone: data?.phone ?? "",
          status:
            statusOption?.filter(
              (item) => item?.id === data?.user_status
            )?.[0] ?? null,
        }}
        onClose={() => setOpen(false)}
        onEditUser={(res, logData) => {
          setOpen(false);
          onEditUser(res, logData);
        }}
        onChangePhoneCode={onChangePhoneCode}
      />
    </div>
  );
}
